// extracted by mini-css-extract-plugin
module.exports = {"features-landing-container":"FeaturesLanding_features-landing-container__2Pp96","list-of-features":"FeaturesLanding_list-of-features__3UA0X"};